import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'enumLabel' })
export class EnumLabelPipe implements PipeTransform {
  transform(value: string, preLabel?: string): any {
    let label: string;

    if (value === null) {
      return '';
    } else {
      if (preLabel) label = preLabel + '.' + value;
      else label = value;

      return label.toUpperCase();
    }
  }
}
